import BaseStore from "./BaseStore";

export default class PageTracker extends BaseStore {
    module = ['PageTracker'];

    setPrevious(page) {
        this.commit('setPrevious', page);
    }

    getPrevious() {
        return this.state('previousPage');
    }
}